import { Vertical } from './vertical';

export class VerticalNotLaunchedError extends Error {
  vertical: Vertical;
  constructor(vertical: Vertical) {
    super();
    this.vertical = vertical;
  }
}
